export default __webpack_public_path__ + "static/media/1816.8d34a3da.png";